/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

/**
 * Changelog Operations
 * 
 * Fetches the changelog content from the SkillShop server.
 */

import { authenticatedFetch } from '@shared/lib/api';
import { handleApiResponse } from '@shared/lib/apiResponse';

export interface ChangelogResponse {
  content: string;
}

/**
 * Get the changelog content
 * SkillShop server endpoint - uses authenticatedFetch
 */
export async function getChangelog(): Promise<ChangelogResponse | null> {
  try {
    const response = await authenticatedFetch('/api/changelog');
    return await handleApiResponse<ChangelogResponse>(response);
  } catch (error) {
    console.error('[SkillShop Service] Error fetching changelog:', error);
    return null;
  }
}
